module.exports = "<ui-view name=header></ui-view><div class=container-app><div class=\"container main\"><ui-view></ui-view></div><ui-view name=copyright></ui-view></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/main/templates/main.tmpl.html
// module id = 3315
// module chunks = 0